<wl-content-section [theme]="theme()">
  <wl-steps
    [headingField]="headingField()!"
    [button]="button()!"
    [steps]="steps()!"
  ></wl-steps>
</wl-content-section>
